<template>
    <fragment>
        <li v-for="locale in locales">
            <a :href="getLink(locale)">
                <country-flag rounded :country="locale === 'en' ? 'us' : locale" />
            </a>
        </li>
    </fragment>
</template>

<script>
import {locales} from "@/i18n/translations";
import Icon from "@/components/icon/Icon";
import CountryFlag from 'vue-country-flag'

export default {
    name: 'LocaleSwitcher',
    components: {Icon, CountryFlag},
    data () {
        return {
            locales
        }
    },
    methods: {
        getLink(locale) {
            switch (locale) {
                case 'de':
                    return location.host.includes('.test')
                        ? 'http://octomated.de.test' + this.$router.currentRoute.path
                        : 'https://octomated.de' + this.$router.currentRoute.path
                case 'br':
                    return location.host.includes('.test')
                        ? 'http://octomated.com.br.test' + this.$router.currentRoute.path
                        : 'https://octomated.com.br' + this.$router.currentRoute.path
                default:
                    return location.host.includes('.test')
                        ? 'http://octomated.com.test' + this.$router.currentRoute.path
                        : 'https://octomated.com' + this.$router.currentRoute.path
            }
        }
    }
}
</script>

<style scoped>
.country-icon {
    width: 40px;
}
.country-icon.as-toggle {
    margin-top: 5px;
}
</style>
